import { styled } from '@mui/material/styles';

import { Box, Typography, IconButton } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import SecureAvatar from 'components/common/SecureAvatar';

// 1. Container for the entire Worker Assigned section
export const WorkerAssignedContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3), // Space below this section
  padding: theme.spacing(2), // Inner padding
}));

// 2. Header Box for "Worker Assigned" title and More button
export const WorkerAssignedHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(1), // Space between header and worker details
}));

// 3. Title for "Worker Assigned"
export const WorkerAssignedTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
}));


export const MoreOptionsButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5), // Smaller padding for a more compact button
  color: theme.palette.action.active, // Standard icon color
}));

// 5. Container for Worker's Avatar and Text Details
export const WorkerDetailsBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  paddingTop: theme.spacing(1),
  borderRadius: theme.shape.borderRadius, // Rounded corners
}));

// 6. Styled Avatar
export const WorkerAvatar = styled(SecureAvatar)(({ theme }) => ({
  width: 60,
  height: 60,
  borderRadius: theme.shape.borderRadius, // Rounded square avatar
}));

// 7. Box for Worker's Text Information (Name, ID, Role)
export const WorkerInfoText = styled(Box)({});

// 8. Typography for Worker's Name
export const WorkerName = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
}));

// 9. Typography for Worker's ID and Role
export const WorkerMetaText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary, // Muted text color
  // Using theme.typography.body2 will match the default body2 size
}));

// 10. Styled MoreHorizIcon for direct use
export const MoreIcon = styled(MoreHorizIcon)({});